import {Component, Input} from '@angular/core';

@Component({
  selector: 'btx-sub-title',
  templateUrl: './sub-title.component.html',
  styleUrls: ['./sub-title.component.scss'],
  standalone: false
})
export class SubTitleComponent {

  @Input("title") title?: string;

  @Input("routerLink") routerLink: any[] | string = [];

}
